<div class="sm-flex sm-flex-row sm-w-full sm-space-x-2" [class.sm-flex-col]="hasReachedPlanLimit">
  <button
    type="button"
    class="add-property-button"
    [class.hidden]="isInCreateMode"
    [class.disabled]="hasReachedPlanLimit"
    (click)="onStartCreateMode()"
    *ngIf="!loading"
  >
    <i class="cc-icon cc-icon-plus"></i>
    <span>Add property</span>
  </button>

  <div *ngIf="loading" class="sm-flex sm-flex-1 sm-justify-center sm-items-center">
    <i class="cc-icon cc-icon-spinner-lg" aria-hidden="true"></i>
  </div>

  <cc-list-property-kind
    [propertyKind]="selectedKind"
    (propertyKindChange)="selectKind($event)"
    *ngIf="isInCreateMode"
  >
  </cc-list-property-kind>

  <cc-text-input
    [value]="propertyName"
    (valueChange)="propertyNameUpdated($event)"
    *ngIf="isInCreateMode"
    size="small"
    placeholder="Type Property Name..."
    (onKeyDown)="onKeyDown($event)"
    [disabled]="!selectedKind"
    data-test="property-name-input"
  ></cc-text-input>

  <cc-limit-reached-list-state
    class="sm-flex sm-flex-col sm-mt-4"
    *ngIf="isUpgradeModalVisible && hasReachedPlanLimit"
  ></cc-limit-reached-list-state>
</div>
